<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {isEqual} from '@/utils/helpers'

    @Component
    export class HotelPageMixin extends Vue {
        async loadRuntimeData(cityId = this.cityId) {
            const cid = cityId || this.cityId
            const promises = []
            // TODO: fix for FillAccommodationBookingDataModal, this.hotelInfoRequest = undefined
            // if (!isEqual(hotelsRuntimeStore.hotelInfoRequest, this.hotelInfoRequest)) {
            if (this.hotelInfoRequest && !isEqual(hotelsRuntimeStore.hotelInfoRequest, this.hotelInfoRequest)) {
                promises.push(hotelsRuntimeStore.loadHotelInfo(this.hotelInfoRequest))
            }
            // TODO: fix for FillAccommodationBookingDataModal, this.cityId = undefined.
            // if (hotelsRuntimeStore.city?.id !== cid) {
            if (cid && hotelsRuntimeStore.city?.id !== cid) {
                promises.push(hotelsRuntimeStore.loadCity(cid))
            }

            await Promise.all(promises)
        }
    }

    export default HotelPageMixin
</script>
